var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RenderAnswer',_vm._b({},'RenderAnswer',{ title:_vm.data.name, body:_vm.data.body, editor: _vm.editor, theme: _vm.theme },false))}
var staticRenderFns = []

export { render, staticRenderFns }